import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgDarkSpotsGlyphSecondary from './svgs/DarkSpotsGlyphSecondary.js';
import SvgDarkSpotsGlyph from './svgs/DarkSpotsGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var darkSpotsGlyph = (props => useIcon(SvgDarkSpotsGlyph, SvgDarkSpotsGlyphSecondary, props));

export { darkSpotsGlyph as default };
